(function ($) {
    $(() => {

        objectFitImages();

        $('.match-h').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });    

        $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            $('.match-h').matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false
            });
          });

        $('.match-h-2').matchHeight({
            byRow: false,
            property: 'height',
            target: null,
            remove: false
        });

        $('.js-parallax').jarallax({
            speed: 0.2,
            disableParallax: /iPad|iPhone|iPod|Android/
        });

        lax.init()

        // Add a driver that we use to control our animations
        lax.addDriver('scrollY', function () {
            return window.scrollY
        })

        // Add animation bindings to elements
        lax.addElements('.js-animation', {
            scrollY: {
                scale: [
                    ['elInY', 'elOutY'],
                    [1.4, 1],
                ]
            }
        })


        //animation
        AOS.init({
            once: true,
            disable: 'mobile'
        });

        //history-slider
        
        $('.js-history-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false,
            autoplaySpeed: 2000,
            speed: 1000,
            infinite: true,
            autoplay: true,
            arrows: false,
            dots: false,
            fade: true,
            cssEase: 'linear'
        });

        //sliders
        $('.js-slider-gallery').each(function (index, value) {
            $(this).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                prevArrow: $(".js-slick-prev", $(this).parent()),
                nextArrow: $(".js-slick-next", $(this).parent()),
            });
        });

        //partner slider 
        $('.js-partner-slider').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            cssEase: 'linear',
            pauseOnHover: false,
            continuousSliding: true,
            speed: 3000,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 0,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });

        //quote slider
        $('.js-quote-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false,
            autoplaySpeed: 10000,
            speed: 1000,
            infinite: true,
            autoplay: true,
            arrows: false,
            dots: false,
            fade: true,
            cssEase: 'linear'
        });

        //change bg
        $('.js-small-image').on('click', function () {
            $('.js-layer').removeClass('active');
            $(this).find('.js-layer').addClass('active');
            const bg = $(this).css('background-image');

            $(this).parent().parent().parent().find('.js-big-image').css('background-image', bg);

        });

        //sumoselect
        if ($('.contact-temaplate').length) {
            $('.js-sumoselect')[0].selectedIndex = -1;
            $('.js-sumoselect-2')[0].selectedIndex = -1;
            $('.js-sumoselect-3')[0].selectedIndex = -1;

            $(document).on('click', '.opt', function () {
                $(this).closest('.form-group').find('.js-label').addClass('active');
                $('.js-form').parsley().validate();
            });
        }

        $('.js-sumoselect').SumoSelect({
            placeholder: 'Select Here',
            forceCustomRendering: true,
            floatWidth: 991
        });

        if ($('.newsroom-archive').length) {
            $(document).on('click', '.opt', function () {
                $('.js-newsroom-archive-form').submit();
            });

            if (location.search !== '') {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".js-newsroom-archive-form").offset().top - 200
                }, 500);
            }
        }

        if ($('.js-blogs-archive').length) {
            $(document).on('click', '.opt', function () {
                $('.js-archive-content-form').submit();
            });

            if (location.search !== '') {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".js-archive-content-form").offset().top - 200
                }, 500);
            }
        }


        //custom label animation

        // INPUT FOCUS EFFECT
        $(".form-control").focusin(function () {
            $(".form-group.is-focused").removeClass("is-focused");
            $(".form-control").each(function () {
                if ($(this).val() === "") {
                    $(this)
                        .parent()
                        .find(".js-label")
                        .removeClass("is-focused");
                }
            });

            $(this)
                .closest(".form-group")
                .addClass("is-focused");
            $(this)
                .parent()
                .find(".js-label")
                .addClass("is-focused");
        });

        //textarea limit
        $('.js-text-limit').keyup(() => {
            const text_length = $('#message').val().length;
            const text_remaining = text_length;

            $('.counter-p').html(`${text_remaining}/150`);
        });

        //form validation
        $('.js-form').parsley({
            trigger: 'change',
            successClass: 'is-success',
            errorClass: 'is-error',
            classHandler(el) {
                return el.$element.closest('.form-group');
            },
            errorsWrapper: '<div class="invalid-message error-text"></div>',
            errorTemplate: '<span></span>'
        });


        //filter content

        $('.js-category').on('click', function () {
            let slug = $(this).data('slug');

            $('.js-check').prop('checked', false);

            if ($(`#js_${slug}`).prop('checked')) {
                $(`#js_${slug}`).prop('checked', false)
            } else {
                $(`#js_${slug}`).prop('checked', true)
            }

            $('.js-archive-content-form').submit();
        });

        $('.js-archive-content-form').submit(function (e) {

            var tags = [];
            $(".js-check").each(function (i) {
                if ($(this).prop('checked')) {
                    tags.push($(this).val())
                }
            });

            if (tags.length !== 0) {
                $('<input/>').attr('type', 'hidden').attr('name', 'tags').attr('value', tags).appendTo('.js-archive-content-form');
            }

            if ($('.js-search-keyword').val() == '') {
                $('.js-search-keyword').removeAttr('name');
            }

            return true;
        });

        //404 animation
        if($('.animation-wrapper-404').length) {
            init();
        }

        // anim-template
        if($('.js-anim-template').length) {
            initAnim();
        }

        //lax animation
        lax.init()

        // Add a driver that we use to control our animations
        lax.addDriver('scrollY', function () {
        return window.scrollY
        })

        // Add animation bindings to elements
        lax.addElements('.js-animation', {
            scrollY: {
                translateY: [
                    ['elInY', 'elOutY'],
                    [-100, -300],
                ],
                translateX: [
                    ['elInY', 'elOutY'],
                    [-200, 120],
                ],
                scale: [
                    ['elInY', 'elOutY'],
                    [1, 0.7],
                ]
            }
        });

        lax.addElements('.js-animation-2', {
            scrollY: {
                translateY: [
                    ['elInY', 'elOutY'],
                    [0, -200],
                ],
            }
        });

        lax.addElements('.js-animation-3', {
            scrollY: {
                translateY: [
                    ['elInY', 'elOutY'],
                    [0, 100],
                ],
            }
        });

    });
})(jQuery);
